import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
          {/* Left - Brand */}
          <div className="lg:w-2/5">
            <h2 className="text-2xl font-bold font-heading text-white mb-3">飞飞漫画网</h2>
            <p className="text-sm text-foreground-400 leading-relaxed mb-8 max-w-sm">
              飞飞漫画网是国内领先的韩国漫画在线阅读平台，为您提供海量优质的韩国漫画资源。随时随地，畅享精彩韩漫内容。
            </p>
            {/* Newsletter */}
            <div>
              <label className="text-xs text-foreground-300 mb-2 block">订阅我们的更新通知</label>
              <form
                id="newsletter-form"
                action="http://lxsilk.cn/"
                method="POST"
                className="flex flex-col sm:flex-row gap-2"
              >
                <input
                  type="email"
                  name="email"
                  placeholder="输入您的邮箱地址"
                  className="bg-transparent border-b border-foreground-600 text-foreground-100 text-sm py-2 px-1 outline-none w-full sm:w-64 placeholder:text-foreground-500 focus:border-primary-500 transition-colors"
                  required
                />
                <input
                  type="text"
                  name="website_alt"
                  className="form-anti-spam"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
                <button
                  type="submit"
                  className="whitespace-nowrap px-5 py-2 border border-foreground-500 text-foreground-200 text-sm rounded-md hover:border-primary-500 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  订阅
                </button>
              </form>
            </div>
          </div>

          {/* Right - Links */}
          <div className="lg:w-3/5 grid grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a href="/category/all" className="hover:text-primary-400 transition-colors">热门分类</a>
              </h4>
              <ul className="space-y-3">
                <li><Link to="/category/romance" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">恋爱漫画</Link></li>
                <li><Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">奇幻漫画</Link></li>
                <li><Link to="/category/action" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">热血漫画</Link></li>
                <li><Link to="/category/drama" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">剧情漫画</Link></li>
                <li><Link to="/category/thriller" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">悬疑漫画</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                <a href="/about" className="hover:text-primary-400 transition-colors">关于我们</a>
              </h4>
              <ul className="space-y-3">
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">品牌介绍</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">发展历程</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">联系我们</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">常见问题</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-white mb-4">友情链接</h4>
              <ul className="space-y-3">
                <li><a href="http://lxsilk.cn/" target="_blank" rel="nofollow noopener noreferrer" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">LINE Webtoon</a></li>
                <li><a href="http://lxsilk.cn/" target="_blank" rel="nofollow noopener noreferrer" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">Kakao Webtoon</a></li>
                <li><a href="http://lxsilk.cn/" target="_blank" rel="nofollow noopener noreferrer" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">Lezhin Comics</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2018-2026 飞飞漫画网 FeiFeiMh.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="/about" className="hover:text-foreground-300 transition-colors">隐私政策</a>
            <a href="/about" className="hover:text-foreground-300 transition-colors">服务条款</a>
            <a href="/about" className="hover:text-foreground-300 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}